import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "../pages/Services.css";
import Navbar from "../components/Navbar";
import ServiceBanner from "./ServiceBanner";
import Footer from "../components/Footer";
import SOLARPLANT from "../images/videos/SOLARPLANT.mp4";
import VID0 from "../images/videos/VIDEOS/VID0.mp4";
import VID1 from "../images/videos/VIDEOS/VID1.mp4";
import VID2 from "../images/videos/VIDEOS/VID2.mp4";
import VID3 from "../images/videos/VIDEOS/VID3.mp4";
import VID4 from "../images/videos/VIDEOS/VID4.mp4";
import VID5 from "../images/videos/VIDEOS/VID5.mp4";
import VID6 from "../images/videos/VIDEOS/VID6.mp4";
import { FaSearchLocation, FaDraftingCompass, FaTruckLoading, FaTools, FaPlug, FaCogs } from "react-icons/fa";
import {
  MdSolarPower,
  MdWaterDrop,
  MdScience,
  MdLocalFireDepartment,
  MdFlashOn,
  MdDeleteSweep
} from "react-icons/md";

export default function Services() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      title: "Solar Installation, Services & Maintenance",
      icon: <MdSolarPower />,
      video: SOLARPLANT,
      link: "/SolarPlant",

      text:
        "  We provide end-to-end solar Installation solutions, from site assessment and system design to installation and commissioning. Our solar projects maximize energy generation and reduce carbon emissions."
    },
    {
      title: "STP – Sewage Treatment Plant",
      icon: <MdWaterDrop />,
      video: VID1,
      link: "/Stp",
      text:
        " At RAD EnviroNex, we design, install, and maintain efficient STP systems that support water conservation and environmental protection by treating wastewater from homes, apartments, hospitals, industries, and commercial buildings. It removes contaminants and produces treated water that is safe for reuse or discharge as per PCB norms"
    },
    {
      title: "ETP – Effluent Treatment Plant",
      icon: <MdScience />,
      video: VID2,
      link: "/Etp",
      text:
        "At RAD EnviroNex, we design and execute customized ETP solutions based on industry type, effluent characteristics and discharge standard. We use advanced and energy efficient technology to achieve high efficiency with reduced power and operating cost.Specialized in water recycling, RO-based reuse, and Zero Liquid Discharge (ZLD) solutions to minimize freshwater dependency"
    },
    {
      title: "Biogas Systems",
      icon: <MdLocalFireDepartment />,
      video: VID3,
      link: "/BioGas",
      text:
        "RAD EnviroNex provides customized biogas solutions that convert organic waste into renewable energy by waste assessment and feasibility study . Our biogas plants help  reduce waste disposal issues, lower energy costs, and promote circular economy practices by generating clean and sustainable fuel. We also provide testing, commissioning and performance guarantee."
    },
    {
      title: "Energy Audit",
      icon: <MdFlashOn />,
      video: VID5,
      link: "/Energy",
      text:
        "Our energy audit services analyze energy consumption patterns to identify inefficiencies and savings opportunities. We deliver detailed assessments and actionable recommendations that help organizations optimize energy use, reduce operational costs, and improve overall efficiency."
    },
    {
      title: "Green Audit",
      icon: <MdFlashOn />,
      video: VID4,
      link: "/Green",
      text:
        "RAD EnviroNex is a professional environmental consultancy providing Green Audit Services to educational institutions, industries, hospitals, and commercial establishments in alignment with NAAC, CPCB, NABH, ESG and sustainability and environmental quality requirements."
    },
    {
      title: "Environmental Audit",
      icon: <MdDeleteSweep />,
      video: VID6,
      link: "/Enivronment",
      text:
        "We offer integrated solid waste management solutions focused on waste reduction, segregation, processing, and responsible disposal. Our approach promotes recycling, composting, and resource recovery, helping organizations manage waste efficiently while minimizing environmental impact."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Our Services | Solar, STP, ETP & Environmental Audits in Madurai</title>
        <meta name="description" content="Explore our range of sustainable services including Solar Power Plants, Sewage Treatment (STP), Effluent Treatment (ETP), Biogas, and Green Audits in Madurai." />
        <meta name="keywords" content="RAD EnviroNex Services, Solar Installation Madurai, STP Maintenance, ETP Design, Green Audit Certification, Energy Audit Services, Biogas systems Madurai" />
        <link rel="canonical" href="https://radenvironex.com/Services" />
      </Helmet>
      <Navbar />

      <ServiceBanner />

      <section id="serv-desc" className="serv-desc-section">
        <div className="container">
          {services.map((item, index) => (
            <div
              className={`row align-items-center serv-row ${index % 2 !== 0 ? "reverse" : ""
                }`}
              key={index}
            >
              {/* TEXT */}
              <div className="col-lg-6" data-aos="slide-up">
                <div className="serv-content">
                  <h3>
                    <span className="serv-icon">{item.icon}</span>
                    {item.title}
                  </h3>

                  {/* TEXT WRAPPER – FIX */}
                  <div className="serv-text">
                    {typeof item.text === "string" ? (
                      <p>{item.text}</p>
                    ) : (
                      item.text
                    )}
                  </div>

                  {/* BUTTON – FIXED POSITION */}
                  <div className="serv-action">
                    <button
                      className="serv-btn"
                      onClick={() => navigate(item.link)}
                    >
                      View Detailed Service →
                    </button>
                  </div>
                </div>
              </div>

              {/* VIDEO */}
              <div className="col-lg-6" data-aos="fade-up">
                <div className="serv-video-box">
                  <video
                    src={item.video}
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>



      <section id="Service-AMC" className="amc-section">

        <div className="container">

          <div className="row text-center mb-5">
            <h2 className="amc-title">End-to-End Project Execution</h2>
            <p className="amc-sub">
              RAD EnviroNex provides complete execution from planning to maintenance
              for Solar, ETP, STP and Bio Gas projects.
            </p>
          </div>

          <div className="amc-grid">

            <div className="amc-card">
              <FaSearchLocation className="amc-icon" />
              <h4>Site Study</h4>
              <p>
                Detailed site inspection and feasibility analysis to understand project
                requirements and environmental conditions.
              </p>
            </div>

            <div className="amc-card">
              <FaDraftingCompass className="amc-icon" />
              <h4>Design</h4>
              <p>
                Custom engineering design and system planning to ensure maximum
                efficiency and performance.
              </p>
            </div>

            <div className="amc-card">
              <FaTruckLoading className="amc-icon" />
              <h4>Supply</h4>
              <p>
                Procurement and supply of high-quality equipment and materials required
                for project execution.
              </p>
            </div>

            <div className="amc-card">
              <FaTools className="amc-icon" />
              <h4>Installation</h4>
              <p>
                Professional installation by experienced technicians following industry
                standards and safety protocols.
              </p>
            </div>

            <div className="amc-card">
              <FaPlug className="amc-icon" />
              <h4>Commissioning</h4>
              <p>
                System testing, integration and activation to ensure smooth operation
                and optimal performance.
              </p>
            </div>

            <div className="amc-card">
              <FaCogs className="amc-icon" />
              <h4>AMC Support</h4>
              <p>
                Annual Maintenance Contracts with regular inspection, servicing and
                technical support.
              </p>
            </div>

          </div>

        </div>

      </section>




      <Footer />
    </>
  );
}
